import React from 'react';
import LazyLoad from 'react-lazyload';
import { MdArrowDropDown } from 'react-icons/md';
import ReactSelect, { components } from 'react-select';
import en from 'react-phone-number-input/locale/en.json';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Datum } from '../../interfaces';
import './phoneinput.scss';
import { useGeoLocation } from '../../hooks/useGeoLocation';
import TextInput from './TextInput';
import Dropdown from '../common/Dropdown';

interface Props {
  wrapperClassName?: string;
  labelClassName?: string;
  className?: string;
  inputClassName?: string;
  selectClassName?: string;
  label?: string;
  id: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  hiddenLabel?: boolean;
  multiline?: boolean;
  helperText?: string;
  value?: PhoneValue;
  rows?: number;
  onChange?: (value?: string) => void;
  customChange?: Function;
  error?: Datum;
  defaultCountry?: string;
  international?: boolean;
  appendStyles?: boolean;
}

export interface PhoneValue {
  country: string;
  countryCode : any;
  phoneNumber: string;
}

interface CountrySelectProps {
  value: string;
  disabled?: boolean;
  className?: string;
  onChange: (country: string) => void;
  labels: {
    [x: string]: string;
  };
}

const Input = (props: any) => (
  <components.Input {...props} autocomplete="nope" />
);

let code;

const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  labels,
  disabled,
  className,
  ...rest
}) => (
  <Dropdown
    position="left"
    disabled={disabled}
    toggleContent={(isVisible) => (
      <div className="flex items-center">
        {/* <img
          alt={value}
          title={labels[value]}
          className="flex-shrink-0 mr-2"
          src={`https://flag.pk/flags/4x3/${value?.toLowerCase()}.svg`}
        /> */}

        <span>+{getCountryCallingCode(value)}</span>
      </div>
    )}
    buttonClassName={`w-full rounded-l-md bg-white h-full flex items-center justify-between px-2 ${className} `}
  >

    
    <div className="bg-white w-96 flex shadow p-4 items-start h-96 overflow-y-auto ">
      <ReactSelect
        placeholder="Search countries"
        name="country-c0de"
        id="country-code-selector"
        instanceId="country-code-selector"
        classNamePrefix="ggl-select"
        closeMenuOnSelect
        options={getCountries().map((country) => ({
          label: `${labels[country]} +${getCountryCallingCode(country)}`,
          value: country,
        }))}
        value={{
          label: `${labels[value]} +${getCountryCallingCode(value)}`,
          value,
        }}
        escapeClearsValue
        className="w-full"
        isSearchable
        openMenuOnClick
        getOptionLabel={(option) => option['label']}
        getOptionValue={(option) => option['value']}
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: '#FFF',
            borderColor: '#D0C9D6',
            borderRadius: '10px',
            padding: '4px',
          }),
          menu: (base) => ({
            ...base,
            boxShadow: 'none',
          }),
          option: (base) => ({
            ...base,
            color: '#000',
            fontWeight: 400,
            fontSize: '14px',
          }),
          placeholder: (base) => ({
            ...base,
            color: '#BDBDBD',
            fontWeight: 400,
            fontSize: '14px',
          }),
        }}
        components={{
          DropdownIndicator: () => <MdArrowDropDown className="text-2xl" />,
          IndicatorSeparator: () => null,
          Input,
        }}
        formatOptionLabel={({ value: valueOpt }) => (
          <div className="flex items-center">
            <LazyLoad overflow>
              {/* <img
                alt={valueOpt}
                className="flex-shrink-0 mr-2"
                src={`https://flag.pk/flags/4x3/${valueOpt?.toLowerCase()}.svg`}
              /> */}
            </LazyLoad>
            <span>
              {labels[valueOpt]} +{getCountryCallingCode(valueOpt)}
            </span>
          </div>
        )}
        autoFocus
        onChange={(selectValue) => {
          onChange(selectValue?.value || 'NG');
        }}
        backspaceRemovesValue={false}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen
        tabSelectsValue={false}
      />
    </div>
  </Dropdown>
);

export const PhoneNumberInput: React.FC<Props> = ({
  wrapperClassName,
  labelClassName,
  selectClassName,
  label,
  id,
  inputClassName,
  placeholder,
  value: valueProps,
  helperText,
  name,
  customChange,
  disabled,
  className,
  error,
  readOnly,
  defaultCountry,
  appendStyles,
}) => {
  const location = useGeoLocation();
  const [value, setValue] = React.useState<PhoneValue>({
    country: valueProps
      ? valueProps.country
      : defaultCountry || location?.country?.short_name || 'NG',
    phoneNumber: valueProps?.phoneNumber || '',
    countryCode: valueProps?.countryCode || '234'
  });

  React.useEffect(() => {
    if (valueProps) {
      setValue(valueProps);
    }

    // console.log('Value Props Here',valueProps);
  }, [valueProps]);

  const handleChange = (selectedValue: string) => {
    setValue({ ...value, phoneNumber: selectedValue });
  };

  React.useEffect(() => {
    !!customChange && customChange(value);
  }, [customChange, value]);

  const errorClass = 'border border-red-600';
  const defaulClass = `border border-gray-400 rounded-md ${
    error ? errorClass : ''
  }`;
  let customClass = className ? `${className} ${error ? errorClass : ''}` : '';
  customClass = appendStyles ? `${className} ${defaulClass}` : customClass;

  return (
    <div className={wrapperClassName}>
      {!!label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={`${customClass || defaulClass} flex flex-grow`}>
        <div>
          <CountrySelect
            className={selectClassName}
            labels={en}
            disabled={disabled}
            value={value.country}
            onChange={(countrArg: string) =>
              setValue({
                ...value,
                country: countrArg,
                countryCode: getCountryCallingCode(countrArg)
              })
            }
          />
        </div>
        <div className="flex-grow">
          <TextInput
            name={name}
            id={name}
            className={inputClassName}
            wrapperClassName="w-full"
            readOnly={readOnly}
            disabled={disabled}
            type="tel"
            placeholder={placeholder}
            customChange={handleChange}
            value={value.phoneNumber}
          />
        </div>
      </div>

      {error?.message && (
        <span
          className={`${
            error?.message ? 'text-red-600' : 'text-gray-600'
          } text-xs`}
        >
          {error.message}
        </span>
      )}
      {helperText && (
        <span className="text-xs text-gray-600">{helperText}</span>
      )}
    </div>
  );
};
